import React, { useState } from 'react';
import { Helmet } from 'react-helmet';
const Gallery = () => {
  // Sample images with unique ids and different src/alt values
  const images = [
    { id: 2, src: '/images/ourfleet/1.jpg', alt: 'Image 2' },
    { id: 3, src: '/images/ourfleet/2.jpg', alt: 'Image 3' },
    { id: 4, src: '/images/ourfleet/3.jpg', alt: 'Image 4' },
    { id: 5, src: '/images/ourfleet/4.jpg', alt: 'Image 5' },
    { id: 6, src: '/images/ourfleet/5.jpg', alt: 'Image 6' },
    { id: 6, src: '/images/ourfleet/6.jpg', alt: 'Image 6' },
    { id: 6, src: '/images/ourfleet/7.jpg', alt: 'Image 6' },
    { id: 1, src: '/images/ourfleet/8.jpg', alt: 'Image 1' },
    { id: 6, src: '/images/ourfleet/9.jpg', alt: 'Image 6' },
    { id: 6, src: '/images/ourfleet/10.webp', alt: 'Image 6' },
    { id: 6, src: '/images/ourfleet/12.webp', alt: 'Image 6' },
    { id: 6, src: '/images/ourfleet/13.jpg', alt: 'Image 6' },
  
  ];

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  // Open modal and set the clicked image
  const openModal = (index) => {
    setCurrentImageIndex(index);
    setIsModalOpen(true);
  };

  // Close modal
  const closeModal = () => {
    setIsModalOpen(false);
  };

  // Show next image in the modal
  const nextImage = () => {
    setCurrentImageIndex((prevIndex) =>
      prevIndex === images.length - 1 ? 0 : prevIndex + 1
    );
  };

  // Show previous image in the modal
  const prevImage = () => {
    setCurrentImageIndex((prevIndex) =>
      prevIndex === 0 ? images.length - 1 : prevIndex - 1
    );
  };


  const productSchema = {
    "@context": "https://schema.org",
    "@type": "Product",
    "name": "Pune to Mumbai Cab",
    "description": "Book your comfortable Pune to Mumbai cab for a smooth and hassle-free journey. Choose from one-way, round trip, and group travel options with both affordable and luxury cabs.",
    "aggregateRating": {
      "@type": "AggregateRating",
      "bestRating": "5",
      "worstRating": "1",
      "ratingValue": "4.7",
      "ratingCount": "450"
    }
  };
  return (

<>


          <Helmet>
          <title>Pune to Mumbai Cab | S9 Travels | Contact: +91 8850328441</title>
              <meta 
                name="description" 
                content="Book a reliable cab for your Pune to Mumbai journey. Affordable and luxury cabs available for one-way, round-trip, and group travel services." 
              />
              {/* Inject JSON-LD Schema */}
              <script type="application/ld+json">
                {JSON.stringify(productSchema)}
              </script>
            </Helmet>
<section className="page-title centred">
    <div className="bg-layer" style={{ backgroundImage: 'url(/images/background/page-title.jpg)' }}></div>
    <div className="auto-container">
      <div className="content-box">
      
        <h1>Gallery</h1>
      </div>
    </div>
  </section>

    
    <div className="gallery-container  ">
      <div className="gallery-grid ">
        {images.map((image, index) => (
          <img
            key={image.id}
            src={image.src}
            alt={image.alt}
            className="gallery-image-item borderr"
            onClick={() => openModal(index)} // Open the modal on click
          />
        ))}
      </div>

      {/* Modal */}
      {isModalOpen && (
        <div className="modal-overlay border">
          <button className="modal-close-button" onClick={closeModal}>
            &times;
          </button>
          <div className="modal-content-container ">
            <button className="modal-prev-button" onClick={prevImage}>
              &#10094;
            </button>
            <div className="modal-image-container">
              <img
                src={images[currentImageIndex].src}
                alt={images[currentImageIndex].alt}
                className="modal-image"
              />
            </div>
            <button className="modal-next-button" onClick={nextImage}>
              &#10095;
            </button>
          </div>
        </div>
      )}
    </div>

</>
  );
};

export default Gallery;